export const AUTH_TOKEN_KEY = 'auth:token'
